// extracted by mini-css-extract-plugin
export default {"button":"CustomPopoverRadio_button__PHqEc","buttonInfo":"CustomPopoverRadio_buttonInfo__ML-Qz"};